import { Image } from 'foundations-components/transitional/components/Image';
import { AgentInitialsIcon } from './internal/AgentInitialsIcon';
import { DefaultAgentIcon } from './internal/DefaultAgentIcon';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { View } from 'foundations-components/transitional/components/View';
import { BREEZE_TOOLTIP_DELAY } from 'chatspot-core/constants/Delays';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AgentIconWithFallback = ({
  size,
  name,
  welcomeMessage,
  iconUrl,
  marginBlockEnd = '400',
  borderRadius = 3,
  background = 'gradient'
}) => {
  if (typeof iconUrl === 'string' && iconUrl.length > 0) {
    return /*#__PURE__*/_jsx(Image, {
      alt: name,
      blockSize: `${size}px`,
      inlineSize: `${size}px`,
      marginBlockEnd: marginBlockEnd,
      shape: "rounded",
      src: iconUrl
    });
  }
  if (typeof name === 'string' && name.length > 0) {
    return /*#__PURE__*/_jsx(Tooltip, {
      delay: BREEZE_TOOLTIP_DELAY,
      title: /*#__PURE__*/_jsxs(View, {
        children: [/*#__PURE__*/_jsx(View, {
          children: name
        }), welcomeMessage && /*#__PURE__*/_jsx(View, {
          marginBlockStart: "200",
          children: welcomeMessage
        })]
      }),
      children: /*#__PURE__*/_jsx(AgentInitialsIcon, {
        agentName: name,
        borderRadius: borderRadius,
        marginBlockEnd: marginBlockEnd,
        size: size,
        background: background
      })
    });
  }
  return /*#__PURE__*/_jsx(Tooltip, {
    delay: BREEZE_TOOLTIP_DELAY,
    title: /*#__PURE__*/_jsx(View, {
      children: "Breeze Copilot"
    }),
    children: /*#__PURE__*/_jsx(DefaultAgentIcon, {
      marginBlockEnd: marginBlockEnd,
      size: size,
      background: background
    })
  });
};